export default {
  permissions: ['BasicInformationMenu/Permissions/'], // ['PermissionsDefinitionMenu', 'AssignPermissionsMenu'],
  priority: 6,
  name: app.translate('routes.home.basic.permission.Permissions'),
  icon: 'account-key',
  drawer: true,
};
